module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/font/glyphicons-halflings-regular.woff
// module id = d+vs
// module chunks = 0